export default __webpack_public_path__ + "static/media/logo.4d2eae9f.svg";